module.exports = __webpack_public_path__ + "static/img/mo.b6d4d1f6.svg";